import { createSlice } from "@reduxjs/toolkit";

const initialState = { value: "", Id: "" };

export const extraSlice = createSlice({
  name: "extra",
  initialState,
  reducers: {
    extrareducer: (state, action) => {
      state.value = action.payload;
    },
    exraContentReducer: (state, action) => {
      state.Id = action.payload;
    },
  },
});
export const { extrareducer, exraContentReducer } = extraSlice.actions;
export default extraSlice.reducer;
